import { Component, OnInit, AfterViewInit, effect, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BackendService } from '@shared/backend.service';
import { ChartConfiguration } from 'chart.js';
import { ProjectDetails } from '@shared/api_interfaces';
import { ProjectService } from '@app/shell/header/header.project.service';
import { CAPTURE_NAV_CONFIG, FLAIRR_NAV_CONFIG } from '@shared/analysis-nav/nav-configs';
import { NavConfig } from '@shared/analysis-nav/analysis-nav.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AnalyticsComponent implements OnInit, AfterViewInit, OnDestroy {
  public _analysis_type: string = '';
  private routeSubscription: Subscription = new Subscription();
  private projectSubscription: Subscription = new Subscription();

  // Navigation configuration
  get navConfig(): NavConfig {
    return this._analysis_type === 'FLAIRR-Seq' ? FLAIRR_NAV_CONFIG : CAPTURE_NAV_CONFIG;
  }

  get analysisType(): 'capture' | 'flairr' {
    return this._analysis_type === 'FLAIRR-Seq' ? 'flairr' : 'capture';
  }

  isLoading = false;
  public projectViewData: any = null;
  selectedLocus: string = '';
  public barChartPlugins = [];

  // Haplotype / novel allele charts
  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
  };

  public barChartNovelSupportOptions: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    scales: {
      x: {
        display: true,
        title: { text: 'No. of supporting haplotypes', display: true },
      },
      y: {
        display: true,
        title: { text: 'No. of novel alleles', display: true },
        type: 'logarithmic',
      },
    },
  };

  constructor(
    private backendService: BackendService,
    public projectService: ProjectService,
    private route: ActivatedRoute
  ) {
    // Set up effect to react to project changes
    effect(() => {
      const project = this.projectService.selectedProjectDetails();
      if (project && this._analysis_type) {
        this.setproject();
      }
    });
  }

  ngOnInit(): void {
    // Get analysis_type from route parameters
    this.routeSubscription = this.route.params.subscribe((params) => {
      const analysisType = params['analysis_type'];
      if (analysisType && analysisType !== this._analysis_type) {
        console.log('Route analysis_type changed to:', analysisType);
        this._analysis_type = analysisType;
        this.setproject();
      }
    });
  }

  ngAfterViewInit(): void {
    console.log('analytics ngAfterViewInit');
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
    this.projectSubscription.unsubscribe();
  }

  // Haplotype / novel allele charts

  // Project / locus selection

  setproject() {
    // Prevent multiple simultaneous calls
    if (this.isLoading) {
      return;
    }

    console.log('Loading project view data for analysis_type:', this._analysis_type);

    const projectDetails = this.projectService.selectedProjectDetails();
    if (!projectDetails || !this._analysis_type) {
      console.log('Missing project details or analysis type');
      return;
    }

    this.isLoading = true;

    // Unsubscribe from previous request if any
    this.projectSubscription.unsubscribe();

    this.projectSubscription = this.backendService
      .getProjectViewData(projectDetails.project_id, this._analysis_type)
      .subscribe({
        next: (response: any) => {
          if (response.status === 200) {
            console.log('got project view data');
            this.projectViewData = response;
          }
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error loading project view data:', error);
          this.isLoading = false;
        },
      });
  }
}
